/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Scope_Offline_AccessInputs */

const en_mcp_connect_scope_offline_access = /** @type {(inputs: Mcp_Connect_Scope_Offline_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay connected between sessions until you disconnect Listening from the app`)
};

const es_mcp_connect_scope_offline_access = /** @type {(inputs: Mcp_Connect_Scope_Offline_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenerse conectada entre sesiones hasta que desconectes Listening de la app`)
};

/**
* | output |
* | --- |
* | "Stay connected between sessions until you disconnect Listening from the app" |
*
* @param {Mcp_Connect_Scope_Offline_AccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_scope_offline_access = /** @type {((inputs?: Mcp_Connect_Scope_Offline_AccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Scope_Offline_AccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_scope_offline_access(inputs)
	return en_mcp_connect_scope_offline_access(inputs)
});